import React from "react";
import { NEFThemeProvider } from "@nef/core";

// import { analytics } from "../services/segment";

import NFNLandingPageComponent from "./app_components/NFNLandingPageComponent";

const IndexPage = (props: any) => {
  // analytics.page({ userId: "NEW_NFN_PAGE_VISIT_TEST", name: "Anonymous user" });
  return (
    <>
      <NEFThemeProvider>
        <NFNLandingPageComponent />
      </NEFThemeProvider>
    </>
  );
};

export default IndexPage;
